import React from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { BlockContainer } from '../../components/layouts';
import { AppLink, Button, RichText } from '../../components';
import styles from './styles.module.scss';
import type { PagesQuery } from '../../graphql/generated/schema';

export const CtaButton: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'CtaButton'>> = ({
  blockSettings,
  buttonType,
  link,
  content,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
  >
    <AppLink
      link={link}
      className={styles.linkContainer}
    >
      <Button
        className={styles.button}
        htmlElement="span"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type={buttonType as any}
      >
        <RichText
          data={content}
        />
      </Button>
    </AppLink>
  </BlockContainer>

);
